module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lumi-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-73fb6b23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiContainer.vue
// module id = 66
// module chunks = 0